import Vue from 'vue'
import Vuex from 'vuex'
import ConstDef from './share/ConstDef'
import AppLib from './share/AppLib'
import pathify from './plugins/vuex-pathify'

// properties
const state = {
  aesKey: null,
  aesIv: null,
  userInfo: null,
  topMenu: null,
  topMenuTab: null,
  baseData: null,
  sysParam: null,
  tempArg: null,
  temp: null,
  carType: null,
  rawMeterial: null,
  companyInfo: null,
  purchaseInoutList: null,
  matarialInfoList: null,
  productOutputList: null,
  productOutputListGby: null,
  token: 10
}

const getters = {
  getAesKey (state) {
    if (state.aesKey === null) {
      state.aesKey = sessionStorage.getItem('aesKey')
    }
    return state.aesKey
  },
  getAesIv (state) {
    if (state.aesIv === null) {
      state.aesIvSingle = sessionStorage.getItem('aesIv')
    }
    return state.aesIv
  },
  getUserInfo (state) {
    if (state.userInfo === null) {
      state.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    }
    return state.userInfo
  },
  getSaveId (state) {
    let result = localStorage.getItem('isSaveId')
    // console.log('called getSaveId result=' + result)
    if ((result !== null && result !== undefined) || result === 'Y') {
      return localStorage.getItem('saveId')
    } else {
      return null
    }
  },
  getTopMenuTabByUrl: (state) => (url) => {
    if (state.topMenuTab === null) {
      state.topMenuTab = JSON.parse(sessionStorage.getItem('topMenuTab'))
    }
    if (state.topMenuTab !== null) {
      for (let i = 0; i < state.topMenuTab.length; i++) {
        if (state.topMenuTab[i].url === url) {
          return state.topMenuTab[i]
        }
      }
    }
    return null
  },
  getIsLogin (state) {
    let userInfo = this.getUserInfo()
    if (userInfo === null) {
      return false
    } else {
      return userInfo.authResult
    }
  },
  getTopMenu (state) {
    if (state.topMenu === null) {
      state.topMenu = JSON.parse(sessionStorage.getItem('topMenu'))
    }
    return state.topMenu
  },
  getSysParam (state) {
    if (state.sysParam === null) {
      state.sysParam = JSON.parse(sessionStorage.getItem('sysParam'))
    }
    return state.sysParam
  },
  getSysParamByKey: (state) => (key) => {
    if (state.sysParam === null) {
      state.sysParam = JSON.parse(sessionStorage.getItem('sysParam'))
    }
    const result = state.sysParam.find(item => item.key === key)
    if (result === undefined || result === null) return null
    return result.value
  },
  getGroupName (state) {
    if (state.sysParam === null) {
      state.sysParam = JSON.parse(sessionStorage.getItem('sysParam'))
    }
    const result = state.sysParam.find(item => item.key === '생산그룹명')
    if (result === undefined || result === null) return null
    return result.value
  },
  // getCarType (state) {
  //   if (state.carType === null) {
  //     state.carType = JSON.parse(sessionStorage.getItem('carType'))
  //   }
  //   return state.carType
  // },
  getCarTypeMass: (state) => (isMass) => {
    if (state.carType === null) {
      state.carType = JSON.parse(sessionStorage.getItem('carType'))
    }
    if (isMass) { return state.carType.filter(item => item.사용유무 === isMass) } else { return state.carType }
  },
  getCarType (state) {
    if (state.carType === null) {
      state.carType = JSON.parse(sessionStorage.getItem('carType'))
    }
    return state.carType
  },
  getRawMeterial (state) {
    if (state.rawMeterial === null) {
      state.rawMeterial = JSON.parse(sessionStorage.getItem('rawMeterial'))
    }
    return state.rawMeterial
  },
  getCustomerInfo (state) {
    if (state.companyInfo === null) {
      state.companyInfo = JSON.parse(sessionStorage.getItem('companyInfo'))
    }
    return state.companyInfo.filter(item => item.거래처구분코드 === '발주사')
  },
  getFirstVendor (state) {
    if (state.companyInfo === null) {
      state.companyInfo = JSON.parse(sessionStorage.getItem('companyInfo'))
    }
    return state.companyInfo.filter(item => item.거래처구분코드 === '발주사')
  },
  getPartnersInfo (state) {
    if (state.companyInfo === null) {
      state.companyInfo = JSON.parse(sessionStorage.getItem('companyInfo'))
    }
    return state.companyInfo.filter(item => item.거래처구분코드 === '협력사')
  },
  getCompanyInfo (state) {
    if (state.companyInfo === null) {
      state.companyInfo = JSON.parse(sessionStorage.getItem('companyInfo'))
    }
    return state.companyInfo
  },
  getBaseData (state) {
    if (state.baseData === null) {
      state.baseData = JSON.parse(sessionStorage.getItem('baseData'))
    }
    return state.baseData
  },
  getBaseDataByType: (state) => (id) => {
    let baseDataArray = []
    if (state.baseData === null) {
      state.baseData = JSON.parse(sessionStorage.getItem('baseData'))
    }
    if (state.baseData !== null) {
      for (let i = 0; i < state.baseData.length; i++) {
        if (state.baseData[i].상위코드 === id) {
          baseDataArray.push(state.baseData[i])
        }
      }
    }
    return baseDataArray
  },
  getTempArgData (state) {
    return state.tempArg
  },
  getTempData (state) {
    return state.temp
  },
  getPurchaseInfoList: (state) => (vendorCode) => {
    if (state.purchaseInoutList === null) {
      return null
    }
    if (vendorCode === 'ALL') {
      return state.purchaseInoutList
    }
    return state.purchaseInoutList.filter(item => item.입고업체 === vendorCode)
  },
  getMatarialInfoList: (state) => (vendorCode) => {
    if (state.matarialInfoList === null) {
      return null
    }
    if (vendorCode === 'ALL') {
      return state.matarialInfoList
    }
    return state.matarialInfoList.filter(item => item.입고업체 === vendorCode)
  },
  getProductOutputList: (state) => (vendorCode) => {
    if (state.productOutputList === null) {
      return null
    }
    if (vendorCode === 'ALL') {
      return state.productOutputList
    }
    return state.productOutputList.filter(item => item.입고업체 === vendorCode)
  },
  getProductOutputListGby: (state) => (vendorCode) => {
    if (state.productOutputList === null) {
      return null
    }
    if (vendorCode === 'ALL') {
      return state.productOutputListGby
    }
    return state.productOutputListGby.filter(item => item.입고업체 === vendorCode)
  },
  // 생산실적/자재입고출고 수정삭제 가능여부(2개월 전 이면 수정불가 : 재고 이월마감관련)
  isInOutCRUDable: (state) => (compareDate) => {
    let date = compareDate
    if (AppLib.isNumeric(compareDate)) {
      date = AppLib.formatDateFromTimeStamp(compareDate)
    } else {
      date = compareDate.substring(0, 10)
    }
    const before2month = `${AppLib.calcMonthFromToday(-1).substring(0, 7)}-01`
    return date >= before2month
  }

}

const actions = {
}

const mutations = {
  saveAesKeyIv (state, { key, iv }) {
    state.aesKey = key
    // // console.log('disk=' + key)
    state.aesIv = iv
    sessionStorage.setItem('aesKey', key)
    sessionStorage.setItem('aesIv', iv)
  },
  saveAesKey (state, key) {
    state.aesKey = key
    sessionStorage.setItem('aesKey', key)
  },
  saveAesIv (state, iv) {
    state.aesIv = iv
    sessionStorage.setItem('aesIv', iv)
  },
  saveId (state, id) {
    localStorage.setItem('isSaveId', 'Y')
    localStorage.setItem('saveId', id)
  },
  saveSysParam (state, param) {
    state.sysParam = param
    sessionStorage.setItem('sysParam', JSON.stringify(param))
  },
  saveCarType (state, param) {
    state.carType = param
    sessionStorage.setItem('carType', JSON.stringify(param))
  },
  saveRawMeterial (state, param) {
    state.rawMeterial = param
    sessionStorage.setItem('rawMeterial', JSON.stringify(param))
  },
  saveCompany (state, param) {
    state.companyInfo = param
    sessionStorage.setItem('companyInfo', JSON.stringify(param))
  },
  deleteSaveId (state) {
    localStorage.setItem('isSaveId', 'N')
    localStorage.removeItem('saveId')
  },
  saveUserInfo (state, userInfo) {
    state.userInfo = userInfo
    sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  saveToken (state, token) {
    state.token = token
    sessionStorage.setItem('token', token)
  },
  deleteUserInfo (state) {
    state.userInfo = null
    sessionStorage.removeItem('userInfo')
  },
  deleteAesKeyIv (state) {
    state.aesKey = null
    state.aesIv = null
    sessionStorage.removeItem('aesKey')
    sessionStorage.removeItem('aesIv')
  },
  deleteBaseData (state) {
    state.baseData = null
    sessionStorage.removeItem('baseData')
  },
  saveTopmenu (state, topMenu) {
    state.topMenu = topMenu
    sessionStorage.setItem('topMenu', JSON.stringify(topMenu))
  },
  saveTopMenuTab (state, topMenuTab) {
    console.log(topMenuTab)
    state.topMenuTab = topMenuTab
    sessionStorage.setItem('topMenuTab', JSON.stringify(topMenuTab))
  },
  saveBaseData (state, baseData) {
    state.baseData = baseData
    sessionStorage.setItem('baseData', JSON.stringify(baseData))
  },
  saveTempArgData (state, arg) {
    state.tempArg = arg
  },
  deleteTempArgData (state) {
    state.tempArg = null
  },
  saveTempData (state, arg) {
    state.temp = arg
  },
  deleteTempData (state) {
    state.temp = null
  },
  deleteInoutList (state) {
    state.purchaseInoutList = null
    state.matarialInfoList = null
    state.productOutputList = null
  },
  saveMatarialInfoListt (state, arg) {
    state.matarialInfoList = arg
  },
  saveProductOutputList (state, arg) {
    state.productOutputList = arg
  },
  savePurchaseInoutList (state, arg) {
    if (arg.option.품목유형 === ConstDef.구매품 && arg.option.자재유형 === ConstDef.자재유형_원자재) {
      state.matarialInfoList = arg.data
    } else if (arg.option.품목유형 === ConstDef.구매품) {
      state.purchaseInoutList = arg.data
    } else {
      state.productOutputList = arg.data
    }
  },
  saveOutListGby (state, arg) {
    state.productOutputListGby = arg.data
  }
}

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    pathify.plugin
  ],
  state,
  getters,
  actions,
  mutations
})
